import { render, staticRenderFns } from "./POReviewResultsDisplay.vue?vue&type=template&id=e5e5b4d8&scoped=true"
import script from "./POReviewResultsDisplay.vue?vue&type=script&lang=ts"
export * from "./POReviewResultsDisplay.vue?vue&type=script&lang=ts"
import style0 from "./POReviewResultsDisplay.vue?vue&type=style&index=0&id=e5e5b4d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e5b4d8",
  null
  
)

export default component.exports